/* eslint-disable */

import Pagination from './module/pagination.js'
const pageActu = document.querySelector('body.template-actualites')

if (pageActu) {

  let options = {
    itemsWrapperSelector: '.inner-cpt-wrapper',
    buttonsWrapperSelector: '.pagination',
    maxItemsPerPages: 6,
    minPage: 1,
    maxPage: 3,
  };

  new Pagination(options);

}


// WEBPACK FOOTER //
// ./scripts/actu.js